export default __webpack_public_path__ + "static/media/quaker.509469a3.svg";